import { render, staticRenderFns } from "./TestToolbar.vue?vue&type=template&id=655a0a00"
import script from "./TestToolbar.vue?vue&type=script&lang=js"
export * from "./TestToolbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports